import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ReportCard;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { jsx } from '@instructure/emotion';
import Card from '../../../../common/components/shared/Card';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
export var ReportCard = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ReportCard = /*#__PURE__*/function (_Component) {
  function ReportCard() {
    _classCallCheck(this, ReportCard);
    return _callSuper(this, ReportCard, arguments);
  }
  _inherits(ReportCard, _Component);
  return _createClass(ReportCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        details = _this$props.details,
        href = _this$props.href;
      return jsx(Card, {
        customStyles: this.props.styles.card
      }, jsx(Text, {
        size: "medium",
        weight: "bold"
      }, name), jsx("div", {
        css: this.props.styles.details
      }, jsx(Text, {
        size: "small",
        color: "secondary"
      }, details)), jsx(Flex, {
        direction: "row",
        justifyItems: "end",
        alignItems: "end",
        height: "100%"
      }, jsx(Link, {
        href: href
      }, jsx(Text, {
        size: "small",
        "data-automation": name
      }, t('View Report')))));
    }
  }]);
}(Component), _defineProperty(_ReportCard, "displayName", 'ReportCard'), _defineProperty(_ReportCard, "componentId", "Quizzes".concat(_ReportCard.displayName)), _defineProperty(_ReportCard, "propTypes", {
  name: PropTypes.node,
  details: PropTypes.node,
  href: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_ReportCard, "defaultProps", {
  name: void 0,
  details: void 0,
  href: void 0
}), _ReportCard)) || _class);
export default ReportCard;